import React from "react";

const Policies = () => {
    return (
        <div className="max-w-3xl mx-auto p-6 bg-white shadow-md rounded-md my-10">
            <h1 className="text-3xl font-bold text-blue-800 mb-6">User Policy</h1>

            <p>
                This User Policy outlines acceptable conduct, usage rules, and behavioural expectations for all users of Teechaa.
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">1. Account Conduct</h2>
            <p>
                You must maintain accurate user information and protect your login credentials. Sharing accounts or impersonating others is strictly prohibited.
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">2. Content Uploads</h2>
            <p>
                Users are only allowed to upload payment receipts for verification purposes. Uploading other content (text, video, images, or files) is not permitted.
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">3. Appropriate Behaviour</h2>
            <p>
                Users must behave respectfully while interacting with the platform or support staff. Harassment, hate speech, or fraudulent activity will result in immediate account suspension.
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">4. Moderation and Enforcement</h2>
            <p>
                Teechaa reserves the right to review and remove uploaded receipts if they appear fraudulent or inappropriate. Persistent violations may lead to account termination.
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">5. Privacy and Data Handling</h2>
            <p>
                All data collected — including uploaded receipts and personal information — will be processed in compliance with Teechaa’s Data Protection & Privacy Policy.
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">6. Reporting Issues</h2>
            <p>
                To report policy violations or technical issues, contact us at{" "}
                <a href="mailto:support@TeeChaa.com">support@TeeChaa.com</a>.
            </p>

            <p className="mt-4 text-gray-600 italic">Updated 11th of November 2025.</p>

            <h1 className="text-3xl font-bold text-blue-800 mt-12 mb-6">Data Protection & Privacy Policy</h1>
            <p>
                This Data Protection & Privacy Policy explains how Teechaa Technologies Limited collects, uses, stores, and protects personal information in compliance with the Nigeria Data Protection Regulation (NDPR).
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">1. Data We Collect</h2>
            <p>We collect personal data you voluntarily provide during account registration or subscription, including:</p>
            <ul className="list-disc ml-6">
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Payment details</li>
                <li>Uploaded payment receipts</li>
            </ul>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">2. Use of Data</h2>
            <p>We use your information to:</p>
            <ul className="list-disc ml-6">
                <li>Provide and manage your account</li>
                <li>Process payments and verify receipts</li>
                <li>Improve our AI-driven learning services</li>
                <li>Communicate updates and service changes</li>
                <li>Comply with legal obligations</li>
            </ul>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">3. Legal Basis for Processing</h2>
            <p>We process your data based on:</p>
            <ul className="list-disc ml-6">
                <li>Your consent</li>
                <li>Contractual necessity</li>
                <li>Compliance with legal obligations under Nigerian law</li>
            </ul>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">4. Data Retention</h2>
            <p>
                Personal data and receipts are retained only as long as necessary for operational or legal reasons, after which they are securely deleted.
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">5. Data Sharing</h2>
            <p>
                We do not sell or rent personal information. Data may be shared only with trusted third-party service providers (e.g., payment processors) under strict confidentiality obligations.
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">6. Data Security</h2>
            <p>
                Teechaa implements administrative, technical, and physical safeguards to protect user data against unauthorised access, alteration, disclosure, or destruction.
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">7. User Rights</h2>
            <p>Under the NDPR, you have rights to:</p>
            <ul className="list-disc ml-6">
                <li>Access your personal data</li>
                <li>Request correction of inaccurate data</li>
                <li>Withdraw consent at any time</li>
                <li>Request deletion of data (subject to legal retention obligations)</li>
            </ul>
            <p>To exercise these rights, email <a href="mailto:support@TeeChaa.com">support@TeeChaa.com</a>.</p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">8. International Transfers</h2>
            <p>
                Teechaa stores and processes data primarily in Nigeria. If data is transferred outside Nigeria, it will be protected under equivalent safeguards.
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">9. Updates to this Policy</h2>
            <p>
                We may update this Privacy Policy periodically. The latest version will always be available on our website. Continued use of Teechaa after changes means you accept the updated terms.
            </p>

            <h2 className="text-2xl font-semibold text-blue-700 mt-6 mb-2">10. Contact</h2>
            <p>
                For privacy inquiries, contact our Data Protection Officer at{" "}
                <a href="mailto:support@TeeChaa.com">support@TeeChaa.com</a>.
            </p>
        </div>
    );
};

export default Policies;
